import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { Inject, Service } from 'vue-di-container';

@Service()
export default class SenderInfoService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;
    public async GetById(id: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            let url;
            url = window.$config.HostName + 'api/sender-requests/' + id;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data.result;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }
    public async GetFileContent(id: string): Promise<string> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/sender-requests/attachments/' + id;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data.result;
        } catch (exception) {
            this.loaderService.HideLoader();
            return '';
        }
    }
    public async GetRequestApprovalHistory(id: string): Promise<any> {
        try {
            const url = window.$config.HostName + 'api/sender-requests/get-request-approval-history/' + id;
            const result = await this.axiosService.axiosInstance.get(url);
            return result.data;
        } catch (exception) {
            return false;
        }
    }
    public async getExtendRequestsHistory(id: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/sender-requests/get-extend-requests-history/' + id;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async GetAIReviewResult(id: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/sender-request-attachment-ai/' + id;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch {
            this.loaderService.HideLoader();
            return {};
        }
    }

    public async recheckAIById(id: string): Promise<any> {
        try {
            const url = `${window.$config.HostName}api/sender-request-attachment-ai/${id}/recheck`;
            const result = await this.axiosService.axiosInstance.post(url);
            return result.data;
        } catch (exception) {
            return false;
        }
    }
    
    public async saveAIResults(
        senderRequestId: string,
        fields: Array<{ fieldName: string; providerInput: string; aiResult: string; status: number; source: string; }>
    ) {
        const url = `${window.$config.HostName}api/sender-request-attachment-ai/${senderRequestId}/results`;
        const body = { fields };
        await this.axiosService.axiosInstance.post(url, body);
    }

    public async saveCriticalSender(id: string, isCriticalSender: boolean): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/senders/save-critical-sender';
            const result = await this.axiosService.axiosInstance.put(url, { id, isCriticalSender});
            return result.data;
        } catch (exception) {
            return false;
        }
        finally {
            this.loaderService.HideLoader();
        }
    }
}
